import { ADAPTER, CURRENCY, currency_code_names, STATUS } from '@voladeum/client';
import { Pair } from 'client/voladeum/pairs/types';

export const pair_default: Pair = {
  pair_id: 0,
  pair_name: '',
  adapter_id: ADAPTER.KRAKEN,
  adapter_name: '',
  base_currency_id: CURRENCY.BITCOIN,
  base_currency_name: '',
  base_currency_code: currency_code_names[CURRENCY.BITCOIN],
  quote_currency_id: CURRENCY.DOLLAR,
  quote_currency_name: '',
  quote_currency_code: currency_code_names[CURRENCY.DOLLAR],
  price: null,
  price_change: null,
  price_change_pct: null,
  high: null,
  low: null,
  volume: null,
  slug: '',
  market_cap: null,
  market_cap_change: null,
  market_cap_rank: 0,
  total_supply: null,
  max_supply: null,
  circulating_supply: null,
  status_id: STATUS.RUNNING,
  status_name: '',
  created_date: new Date(),
  update_date: new Date(),
  price_formatted: '',
  price_change_formatted: '',
  price_change_pct_formatted: '',
  high_formatted: '',
  low_formatted: '',
  volume_formatted: '',
  market_cap_formatted: '',
  market_cap_change_formatted: '',
  market_cap_rank_formatted: '',
  total_supply_formatted: '',
  max_supply_formatted: '',
  circulating_supply_formatted: '',
  uuid: '',
};
